module.exports = __webpack_public_path__ + "img/8.0a10da8f.png";